import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useUsuario, UsuarioProvider } from '../context/usuarioContext';
import { refreshToken, logout } from '../services/authService';
import IdleSessionManager from '../components/IdleSessionManager/IdleSessionManager';

// Inicio
import DashboardLayout from '../layouts/DashboardLayout';
import Dashboard from "../pages/dashboard/dashboard";

// Inventario
import Inventario from "../pages/inventario-tk/inventario";
import RepInventarioTK from "../pages/reportes/rep-inventario-tk";

// Taller Mecanico
import TallerMecanico from "../pages/taller-mecanico/mecanica";
import InformeMantencion from "../pages/taller-mecanico/informe-mantencion";
import VerInformesTM from '../pages/taller-mecanico/ver-informes';
import VerHistorialVehicular from '../pages/taller-mecanico/historico-vehicular';
import InformeTallerPasos from '../pages/taller-mecanico/informe-taller-pasos';
import SeguimientoInformes from '../pages/taller-mecanico/servicios-tallermec';

// Panel Vehículos
import PanelVehiculos from '../pages/panel-vehiculos/panel-vehiculos';

// Panel Condutores
import PanelConductor from '../pages/panel-conductor/panel-conductor';
import CklSomnolencia from '../pages/panel-conductor/ckl-somnolencia';
import CklVehiculo from '../pages/panel-conductor/ckl-vehiculo';
import MiSomnolencia from '../pages/panel-conductor/mi-somnolencia';
import MiRevisionVehicular from '../pages/panel-conductor/mi-revision-vehicular';

// Panel Prevencion
import PanelPrevencion from '../pages/panel-prevencion/panel-prevencion';
import HistChkSomnolencia from '../pages/panel-prevencion/hist-chk-somnolencia';
import HistChkVehiculo from '../pages/panel-prevencion/hist-chk-vehiculo';

// Gestion de Personas
import GestionPersonas from '../pages/gestion-personas/gestion-personas';
import CrearPersona from '../pages/gestion-personas/crear-persona';
import RestablecerContrasena from '../pages/gestion-personas/restablecer-contrasena';
import VerPersonas from '../pages/gestion-personas/ver-personas';
import CambiarContrasena from '../components/cambiar-contrasena/cambiar-contrasena';

const ShellPrivado = () => {
  return (
    <>
      {/* Se monta una sola vez en el área autenticada */}
      <IdleSessionManager
        refreshToken={refreshToken}
        logout={async () => {
          await logout();
          window.location.href = "/auth/login";
        }}
        //Tiempo de inactividad 10s TEST
        // idleMs={10*1000}
        //Tiempo de gracia para responder 10s TEST
        // graceMs={500*1000}
      />
      <DashboardLayout />
    </>
  );
};

const RutasPrivadas = () => {
  const { usuario } = useUsuario();
  
  if (!usuario) {
    return <Navigate to="/auth/login" replace />;
  }

  return (
    <Routes>
      <Route path="/" element={<ShellPrivado />}>
        <Route index element={<Dashboard />} />

        {/* Inventario */}
        <Route path="inventario-tk" element={<Inventario />} />
          <Route path="reporte/inventario-tk" element={<RepInventarioTK />} />

        {/* Taller Mecanico */}
        <Route path="taller" element={<TallerMecanico />} />
          {/* Revisión vehicular */}
          <Route path="taller/crear/revision-vehicular" element={<InformeMantencion />} />
          <Route path="taller/editar/revision-vehicular/:numeroOT" element={<InformeMantencion />} />
          <Route path="taller/ver/revisiones-vehiculares" element={<VerInformesTM />} />
          <Route path="taller/ver/historico-vehicular" element={<VerHistorialVehicular />} />
          <Route path="taller/revisiones/:revisionId" element={<InformeTallerPasos />} />
          <Route path="taller/revisiones/nuevo" element={<InformeTallerPasos />} />
          <Route path="taller/seguimiento-informes" element={<SeguimientoInformes />} />

        {/* Panel del Conductor */}
        <Route path="panel-conductor" element={<PanelConductor />} />
          {/* Checklist Somnolencia */}
          <Route path="panel-conductor/crear/checklist-somnolencia" element={<CklSomnolencia />} />
          <Route path="panel-conductor/ver/mi-somnolencia" element={<MiSomnolencia />} />
          
          {/* Checklist Vehículo */}
          <Route path="panel-conductor/crear/checklist-vehiculo" element={<CklVehiculo />} />
          <Route path="panel-conductor/ver/mi-revision-vehicular" element={<MiRevisionVehicular />} />
          
        {/* Panel de Vehículos */}
        <Route path="panel-vehiculos" element={<PanelVehiculos />} />

        {/* Panel de Prevención */}
        <Route path="panel-prevencion" element={<PanelPrevencion />} />
          {/* Tabla general informes (checklist) completados */}
          <Route path="panel-prevencion/ver/checklists-somnolencia" element={<HistChkSomnolencia />} />
          <Route path="panel-prevencion/ver/checklists-vehiculos" element={<HistChkVehiculo />} />

        {/* Panel de Supervición */}
        <Route path="panel-supervicion" element={<Dashboard />} />

        {/* Panel de Coordinación */}
        <Route path="panel-coordinacion" element={<Dashboard />} />

        {/* Gestión de Personas */}
        <Route path="gestion-personas" element={<GestionPersonas />} />
          <Route path="gestion-personas/persona/crear-nuevo" element={<CrearPersona />} />
          <Route path="gestion-personas/usuario/administrar" element={<RestablecerContrasena />} />
          <Route path="gestion-personas/ver/personas" element={<VerPersonas />} />

        {/* Configuración de cuenta */}
        <Route path="perfil/cambiar-contrasena" element={<CambiarContrasena />} />
      
      
      </Route>
    </Routes>
  );
};

const DashboardRoutes = () => {
  return (
    <UsuarioProvider> 
      <RutasPrivadas />
    </UsuarioProvider>
  );
};

export default DashboardRoutes;

